import clsx from "clsx"

import type { Nullish, PropsWithClassName } from "~/@types/generics"
import type { TProductHeaderBundle } from "~/components/ui/Product/ProductHeader/_data/serializer"
import { findVariantFromSelectedOptions } from "~/components/ui/Product/ProductHeader/ProductDetails/BundleSelector/utils/find-variant-from-selected-options"
import { getSelectDefaultValues } from "~/components/ui/Product/ProductHeader/ProductDetails/BundleSelector/utils/get-select-default-values"

import { sprinkles, type Sprinkles } from "~/styles/sprinkles.css"
import { text } from "~/styles/variants"

import * as css from "./styles.css"

type BundlePriceProps = PropsWithClassName<{
  sprinklesCss?: Sprinkles
  productHeader: TProductHeaderBundle
  currentOptions?: Nullish<string[]>
}>

export function BundlePrice({ className, sprinklesCss, productHeader, currentOptions }: BundlePriceProps) {
  // Default options
  const reducedDefaultValues = getSelectDefaultValues(currentOptions, productHeader.defaultBundleOptions)

  // Getting the currentVariant
  const currentVariant = findVariantFromSelectedOptions(reducedDefaultValues, productHeader.bundleVariants)

  return (
    <p
      className={clsx(
        css.price,
        text({
          design: "riposte-13",
          weight: "medium",
          transform: "uppercase",
          color: "blue-deep",
          lineHeight: 1,
          letterSpacing: 1,
        }),
        className,
        sprinkles(sprinklesCss ?? {})
      )}
      data-comp="UI/Product/ProductHeader/ProductDetails/ProductPrice"
    >
      {currentVariant?.price}
    </p>
  )
}
